/**
 * Знак пары: две личные печати и общий символ между ними. Третий знак —
 * не «сумма» и не оценка, а просто отметка, что связь существует.
 * Геометрия из утверждённого макета 06.
 */
export function PairSeal({
  firstGlyph,
  secondGlyph,
  secondName,
}: {
  firstGlyph: string
  secondGlyph: string
  secondName: string
}) {
  return (
    <svg className="pair-seal" viewBox="0 0 350 238" width="350" height="238" role="img" aria-label="Знак вашей пары">
      {/* твоя печать */}
      <circle cx="95" cy="72" r="50" fill="none" stroke="rgba(199,203,217,.38)" strokeWidth="1.5" />
      <circle cx="95" cy="72" r="44" fill="none" stroke="rgba(199,203,217,.2)" strokeWidth="2" strokeDasharray="1.2 4.6" />
      <circle cx="95" cy="72" r="25" fill="#151827" stroke="#C9924D" strokeWidth="1.8" />
      <text x="95" y="81" textAnchor="middle" className="pair-glyph" fill="#DCA55F">
        {firstGlyph}
      </text>
      <text x="95" y="142" textAnchor="middle" className="pair-name" fill="#A9A6AE">
        ТЫ
      </text>

      {/* печать второго */}
      <circle cx="255" cy="72" r="50" fill="none" stroke="rgba(199,203,217,.38)" strokeWidth="1.5" />
      <circle cx="255" cy="72" r="44" fill="none" stroke="rgba(199,203,217,.2)" strokeWidth="2" strokeDasharray="1.2 4.6" />
      <circle cx="255" cy="72" r="25" fill="#191420" stroke="#D26A4A" strokeWidth="1.8" />
      <text x="255" y="81" textAnchor="middle" className="pair-glyph" fill="#E08A66">
        {secondGlyph}
      </text>
      <text x="255" y="142" textAnchor="middle" className="pair-name" fill="#A9A6AE">
        {secondName.toUpperCase().slice(0, 12)}
      </text>

      {/* нити к знаку пары */}
      <path d="M113 116 Q140 148 158 172" fill="none" stroke="rgba(199,203,217,.25)" strokeWidth="1.2" />
      <path d="M237 116 Q210 148 192 172" fill="none" stroke="rgba(199,203,217,.25)" strokeWidth="1.2" />

      {/* общий знак */}
      <circle cx="175" cy="186" r="42" fill="none" stroke="rgba(216,179,106,.35)" strokeWidth="1.2" strokeDasharray="2.5 4.5" />
      <circle cx="162" cy="186" r="23" fill="none" stroke="#C7CBD9" strokeWidth="1.6" />
      <circle cx="188" cy="186" r="23" fill="none" stroke="#C7CBD9" strokeWidth="1.6" />
      <path d="M175 175l8.5 11-8.5 11-8.5-11z" fill="#D8B36A" />
    </svg>
  )
}
